import { AgResourceLanguage } from '../types';
import { commonContent as EnUsCommonContent } from '../en-us/commonContent';

export const commonContent: AgResourceLanguage['commonContent'] = {
  ...EnUsCommonContent,
  orderBodyContent: {
    nextOnlyLabel: 'Une seule fois',
    outOfStockLabel: 'Rupture de stock',
    quantityLabel: 'Quantité :',
    productHiddenLabel: 'Produit',
    productsSubtitle: 'Produits',
    subscriptionTitle: 'Subscription',
    otpTitle: 'This order only'
  },
  referFriendCard: {
    title: 'Recommandez à des amis',
    text: 'Recevez 15 € pour chaque ami que vous recommandez dès qu’ils effectuent leur premier achat.'
  },
  slider: {
    empty: {
      title: 'Nos abonnements'
    },
    notEmpty: {
      title: 'La Boutique AG1',
      description: 'Exclusivement disponible pour les membres'
    },
    cardContent: {
      addToSubscription: 'Ajouter à l’abonnement',
      addedToSubscription: 'Ajouté à l’abonnement',
      addToNextOrder: 'Ajouter à la prochaine commande',
      addedToNextOrder: 'Ajouté à la prochaine commande',
      maxQuantityReached: 'Quantité maximale atteinte',
      agzOtpButton: 'for $89',
      agzDisclaimer: '† When bundled in a subscription with AG1. An AGZ only subscription is $79.'
    }
  },
  buttons: {
    subscribeAndSave: 'Abonnez-vous & Économisez',
    subscribe: 'S’abonner',
    delete: 'Supprimer'
  },
  status: {
    fulfilled: 'Traitée',
    partial: 'Partiellement traitée',
    paid: 'Envoi en cours de traitement',
    refunded: 'Remboursée',
    partially: 'Partiellement remboursée',
    unpaid: 'Non payée'
  },
  statusV2: {
    Unfulfilled: 'En préparation',
    Fulfilled: 'Expédiée',
    'On hold': 'En préparation'
  }
};
